import * as Yup from 'yup';

// import ApproverSet from './ApproverSet';

const ChangePasswordSchema = {
        oldpassword: Yup.string().required("Old Password is required").nullable(),
        newpassword: Yup.string().nullable(),
        verifypassword: Yup.string().nullable()
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
        yupValidations: ChangePasswordSchema,
        customValidations: {
        },
};
